module.exports = __webpack_public_path__ + "static/media/bariol_regular.264c746f6fd2bfb72714af1941fdfbff66bcf81adfd4ba6c7285f26d2423af8d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/bariol_regular.ttf
// module id = 785
// module chunks = 204